import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Button,
  Typography,
  useMediaQuery,
  useTheme,
  Stepper,
  Step,
  StepLabel,
  StepConnector,
  stepConnectorClasses
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InfoIcon from "@mui/icons-material/Info";
import WorkIcon from "@mui/icons-material/Work";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import LeaveIcon from "@mui/icons-material/EventAvailable"; // For leave
import ReceiptIcon from "@mui/icons-material/Receipt";

import { Formik, Form } from "formik";
import * as Yup from "yup";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { FadeLoader } from "react-spinners";
import BasicInformationForm from "./tabs/BasicInformationForm";
import PermissionsTab from "./tabs/PermissionsForm";
import EmploymentDetailsTab from "./tabs/EmploymentDetailsForm";
import SalaryInformationTab from "./tabs/SalaryInfoForm";
import LeaveInformationTab from "./tabs/LeaveInfoForm";
import ChallansTab from "./tabs/ChallansForm";
import MasterViewController from "../../redux/actions/masterApiActions";
import EmployeeProfileVeiwController from "../../redux/actions/EmployeeProfileApiAction";
import PayrollViewController from "../../redux/actions/payrollApiAction";
import LeaveViewController from "../../redux/actions/leaveApiAction";
import { getUserInfoFromToken } from "../../utils/authUtils";
import defaultPermissionsData from "../../JsonFile/PermisssionJsonfile.json";

// Your validationSchema and initialPermissions here (unchanged)

const steps = [
  { label: "Basic Information", icon: <InfoIcon /> },
  { label: "Employment Details", icon: <WorkIcon /> },
  { label: "Salary Details", icon: <MonetizationOnIcon /> },
  { label: "Leave Details", icon: <LeaveIcon /> },
  { label: "Challans", icon: <ReceiptIcon /> },
  { label: "Permissions", icon: <CheckCircleIcon /> }
];

const stepValidationSchemas = [
  Yup.object({
    first_name: Yup.string().required("First Name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
  }),
  Yup.object({
    department: Yup.string().required("Department is required"),
    designation: Yup.string().required("Designation is required"),
    joining_date: Yup.string().required("Joining Date is required"),
    employment_type: Yup.string().required("Employment Type is required"),
    work_location: Yup.string().required("Work Location is required"),
    // reporting_manager: Yup.string().required("Reporting Manager is required"),
    employee_status: Yup.string().required("Employee Status is required")
  }),
  Yup.object({
    basic_salary: Yup.number()
      .min(0, "Must be non-negative")
      .required("Basic Salary is required")
  }),
  Yup.object({
    // leave_approval_managers: Yup.array()
    //   .of(Yup.string())
    //   .min(1, "Select at least one manager")
    //   .required("Leave Approval Manager is required"),
    //   leave_year: Yup.number().min(0, "Must be non-negative").required("Leave Year is required"),
    //   attendance_type: Yup.string()
    //     .required("Attendance type is required"),
    //  overtime_eligible: Yup.string()
    // .oneOf(["Yes", "No"], "Select Yes or No")
    // .required("Overtime eligibility is required"),

    casual_leave_balance: Yup.number()
      .min(0, "Must be non-negative")
      .required("Casual Leave Balance is required"),
    sick_leave_balance: Yup.number()
      .min(0, "Must be non-negative")
      .required("Sick Leave Balance is required"),
    maternity_leave_balance: Yup.number()
      .min(0, "Must be non-negative")
      .required("Maternity Leave Balance is required"),
    compensatory_off_leave_balance: Yup.number()
      .min(0, "Must be non-negative")
      .required("Compensatory Off Leave Balance is required")
  }),
  Yup.object({}) // Permissions step may not need validation
];

// Customized connector with colors
const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      background: "linear-gradient(90deg, #f27121, #e94057, #8a2387)"
    }
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      background: "linear-gradient(90deg, #f27121, #e94057, #8a2387)"
    }
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderRadius: 1
  }
}));

// Customized step icon component with color change
const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  background: ownerState.active
    ? "#2575fc" // Active step (blue)
    : ownerState.completed
    ? "linear-gradient(90deg, #f27121, #e94057, #8a2387)" // Completed step
    : "#cfd8dc", // Inactive step
  zIndex: 1,
  color: "#fff",
  width: 40,
  height: 40,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center"
}));

function ColorlibStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    1: <InfoIcon />,
    2: <WorkIcon />,
    3: <MonetizationOnIcon />,
    4: <LeaveIcon />,
    5: <ReceiptIcon />,
    6: <CheckCircleIcon />
  };

  return (
    <ColorlibStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

const AddEmployeeModal = ({ open, handleClose, initialData = null }) => {
  const [activeStep, setActiveStep] = useState(0);
  const [permissions, setPermissions] = useState([]);
  const [challan, setChallan] = useState([]);
  const [employeeId, setEmployeeId] = useState(initialData?.id || null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const dispatch = useDispatch();
  const isEdit = Boolean(initialData?.id);
  const { getPermissionsModules } = MasterViewController();
  const { getChallanMaster } = MasterViewController();
  const { addEmployee, updateEmployee } = EmployeeProfileVeiwController();
  const { permission_modules } = useSelector((state) => state.master);
  const { challans } = useSelector((state) => state.master);
  const { isLoding } = useSelector((state) => state.employeeProfile);
  const { employee_data } = useSelector((state) => state.employeeProfile);
  const employees = employee_data?.employees || [];
  const contentRef = useRef(null);
  const [userType, setUserType] = useState(null);
  const [userId, setUserId] = useState(null);
  // const [submittingLoader, setSubmittingLoader] = useState(false);

  // useEffect(() => {
  //   if (open) {
  //     setActiveStep(0);
  //     setPermissions(initialData?.permissions?.permissions || []); // or [] for add
  //     setEmployeeId(initialData?.id || null);
  //     console.log("Modal opened, initializing form...");
  //   }
  // }, [open]);

  useEffect(() => {
    if (open) {
      setActiveStep(0);
      setEmployeeId(initialData?.id || null);
      setChallan(
        Array.isArray(initialData?.employee_salary?.challans)
          ? initialData.employee_salary.challans
          : []
      );
    }
  }, [open]);
  const formikRef = useRef();
      useEffect(() => {
      const { userType, userId } = getUserInfoFromToken();
      setUserType(userType);
      setUserId(userId);
    }, []);


  useEffect(() => {
   if (userType) {
        console.log("userType:", userType, "userId:", userId);
        dispatch(getPermissionsModules(userType));
      }
    dispatch(getChallanMaster());
  }, [dispatch, userType]);

  
  useEffect(() => {
    if (open) {
      if (initialData?.permissions?.permissions?.length) {
        const clearedPermissions = permission_modules.map((mod) => {
          const row = {
            module: mod.key,
            moduleLabel: mod.label,
            enabled: false
          };
          mod.actions.forEach((act) => {
            row[act.key] = false;
          });
          return row;
        });
        setPermissions(clearedPermissions);
        const patchedData = clearedPermissions.map((masterItem) => {
          const incomingItem = initialData.permissions.permissions.find(
            (i) => i.module === masterItem.module
          );

          if (incomingItem) {
            return {
              ...masterItem,
              ...incomingItem // overwrites values from incoming
            };
          }

          return masterItem; // unchanged if not found in incoming
        });

        // Edit Mode: use existing permissions
        setPermissions(patchedData);
      } else if (permission_modules?.length) {
          // Add Mode: patch default permissions from JSON
          const clearedPermissions = permission_modules.map((mod) => {
            const defaultItem =
              defaultPermissionsData.permissions.employee.find(
                (p) => p.module === mod.key
              ) || {};
      
            const row = {
              module: mod.key,
              moduleLabel: mod.label,
              enabled: defaultItem.enabled || false,
            };
      
            mod.actions.forEach((act) => {
              row[act.key] = defaultItem[act.key] ?? false; // patch from JSON if exists, else false
            });
      
            return row;
          });
      
          setPermissions(clearedPermissions);
      }
    }
  }, [open, initialData, permission_modules]);

  const handleNext = async (formik) => {
    const errors = await formik.validateForm();
    formik.setTouched(
      Object.keys(stepValidationSchemas[activeStep].fields).reduce(
        (acc, field) => {
          acc[field] = true;
          return acc;
        },
        {}
      )
    );

    if (Object.keys(errors).length === 0) {
      setActiveStep((prev) => prev + 1);
      if (contentRef.current) {
        contentRef.current.scrollTo({ top: 0, behavior: "smooth" });
      }
    }
  };

  const handleStepIconClick = async (targetStepIndex, formik) => {
    // Allow going backward
    if (targetStepIndex < activeStep) {
      setActiveStep(targetStepIndex);
      return;
    }

    // Validate current step before proceeding
    const errors = await formik.validateForm();

    formik.setTouched(
      Object.keys(stepValidationSchemas[activeStep].fields).reduce(
        (acc, field) => {
          acc[field] = true;
          return acc;
        },
        {}
      )
    );

    // If no errors, allow moving to the clicked step
    if (Object.keys(errors).length === 0) {
      setActiveStep(targetStepIndex);
    }
  };

  const handleFinalSubmit = async (values, setSubmitting) => {
    setSubmitting(true);
    // setSubmittingLoader(true)

    try {
      const combinedData = {
        id: values.id,
        company_id: values.company_id,
        first_name: values.first_name,
        last_name: values.last_name,
        email: values.email,
        // mobile_number: values.mobile_number,
        // alternative_mobile_number: values.alternative_mobile_number,
        // gender: values.gender,
        // nationality: values.nationality,
        profile: {
          joining_date: values.joining_date,
          department: values.department,
          designation: values.designation,
          employment_type: values.employment_type,
          work_location: values.work_location,
          reporting_manager: values.reporting_manager,
          employee_status: values.employee_status,
          job_description: values.job_description,
          shift_timing: values.shift_timing,
          weekly_off: Array.isArray(values.weekly_off)
            ? values.weekly_off.join(", ")
            : values.weekly_off,
          working_hours: values.working_hours
        },
        employee_salary: {
          employee: values.id,
          basic_salary: values.basic_salary,
          other_allowances: values.other_allowances,
          deductions: values.deductions,
          hra: values.hra,
          bonus: values.bonus,
          challans: challan || []
        },
        leave_balance: {
          // employee: values.id,
          paid_leave_balance: values.paid_leave_balance,
          unpaid_leave_balance: values.unpaid_leave_balance,
          leave_approval_managers: values.leave_approval_managers,
          leave_year: values.leave_year,
          attendance_type: values.attendance_type,
          overtime_eligible: values.overtime_eligible,
          casual_leave_balance: values.casual_leave_balance,
          sick_leave_balance: values.sick_leave_balance,
          maternity_leave_balance: values.maternity_leave_balance,
          marriage_leave_balance: values.marriage_leave_balance,
          compensatory_off_leave_balance: values.compensatory_off_leave_balance
        },
        permissions: permissions.length > 0 ? { permissions: permissions } : {}
      };

      let success = false;
      if (isEdit) {
        success = await dispatch(updateEmployee(values.id, combinedData));
      } else {
        success = await dispatch(addEmployee(combinedData));
      }

      if (success) {
        handleClose(); // ✅ Only called when success
      }
    } catch (error) {
      console.error("Failed to submit combined data:", error);
    } finally {
      setSubmitting(false);
    }
  };
  console.log("id", initialData?.id);

  const getInitialValues = () => ({
    id: initialData?.id || null,
    company: initialData?.company.id || "",
    first_name: initialData?.first_name || "",
    last_name: initialData?.last_name || "",
    email: initialData?.email || "",
    // mobile_number: initialData?.mobile_number || "",
    // alternative_mobile_number: initialData?.alternative_mobile_number || "",
    // gender: initialData?.gender || "",
    // nationality: initialData?.nationality || "",

    department: initialData?.profile_data?.department || "",
    designation: initialData?.profile_data?.designation || "",
    joining_date: initialData?.profile_data?.joining_date || "",
    employment_type: initialData?.profile_data?.employment_type || "",
    work_location: initialData?.profile_data?.work_location || "",
    reporting_manager: initialData?.profile_data?.reporting_manager?.id || "",
    employee_status: initialData?.profile_data?.employee_status || "",
    job_description: initialData?.profile_data?.job_description || "",
    shift_timing: initialData?.profile_data?.shift_timing || "",
    weekly_off: initialData?.profile_data?.weekly_off
      ? initialData.profile_data.weekly_off.split(",").map((day) => day.trim())
      : [],
    working_hours: initialData?.profile_data?.working_hours || "",

    basic_salary: initialData?.employee_salary?.basic_salary || "",
    other_allowances: initialData?.employee_salary?.other_allowances || "",
    deductions: initialData?.employee_salary?.deductions || "",
    bank_name: initialData?.employee_salary?.bank_name || "",
    account_number: initialData?.employee_salary?.account_number || "",
    hra: initialData?.employee_salary?.hra || "",
    bonus: initialData?.employee_salary?.bonus || "",
    ifsc_code: initialData?.employee_salary?.ifsc_code || "",
    pan_number: initialData?.employee_salary?.pan_number || "",
    pf_number: initialData?.employee_salary?.pf_number || "",
    esi_number: initialData?.employee_salary?.esi_number || "",

    paid_leave_balance: initialData?.leave_balance?.paid_leave_balance || 0,
    unpaid_leave_balance: initialData?.leave_balance?.unpaid_leave_balance || 0,
    leave_approval_managers: initialData?.leave_balance?.leave_approval_managers
      ? initialData.leave_balance.leave_approval_managers.map(
          (manager) => manager.id
        )
      : [],
    leave_year: initialData?.leave_balance?.leave_year || "",
    attendance_type: initialData?.leave_balance?.attendance_type || "",
    overtime_eligible:
      initialData?.leave_balance?.overtime_eligible === true
        ? "Yes"
        : initialData?.leave_balance?.overtime_eligible === false
        ? "No"
        : "",
    casual_leave_balance: initialData?.leave_balance?.casual_leave_balance || 0,
    sick_leave_balance: initialData?.leave_balance?.sick_leave_balance || 0,
    maternity_leave_balance:
      initialData?.leave_balance?.maternity_leave_balance || 0,
    marriage_leave_balance:
      initialData?.leave_balance?.marriage_leave_balance || 0,
    compensatory_off_leave_balance:
      initialData?.leave_balance?.compensatory_off_leave_balance || 0
  });

  return (
    <Dialog
    sx={{
      height:'100%',
      width: '100%',
      maxWidth: 'none',
      maxHeight: 'none',
      margin: 0,
    }}
      open={open}
      onClose={handleClose}
      fullScreen
      // fullWidth={!isMobile}
      // maxWidth={isMobile ? false : "md"}
      // PaperProps={{
      //   sx: {
      //     height: "100% !important",
      //     width: "100% !important",
      //     maxWidth: "none !important",
      //     borderRadius: 2,
      //     flexDirection: "column"
      //     // ...(isMobile && {
      //     //   width: "95vw",
      //     //   maxWidth: "95vw",
      //     //   m: 1
      //     // })
      //   }
      // }}
    >
      <Formik
        initialValues={getInitialValues()}
        validationSchema={stepValidationSchemas[activeStep]}
        enableReinitialize
        onSubmit={(values, { setSubmitting }) => setSubmitting(false)}
      >
        {(formikProps) => {
          const { isSubmitting, values, setSubmitting } = formikProps;

          return (
            <Form
              style={{
                display: "flex",
                flexDirection: "column",
                height: "100%"
                // height: "calc(100vh - 64px)", // or set a custom height as needed
                // maxHeight: "90vh" // ensures dialog doesn't overflow screen
              }}
            >
              {/* Sticky Header */}
              <Box
                sx={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1000,
                  backgroundColor: "background.paper",
                  px: 3,
                  pt: 2
                }}
              >
                <DialogTitle
                  sx={{
                    borderBottom: 1,
                    borderColor: "divider",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "0 0 16px 0"
                  }}
                >
                  <Box>
                    {isEdit ? "Edit Employee" : "Add New Employee"}
                    {/* {employeeId && (
                      <Typography variant="body2">
                        Employee ID: {employeeId}
                      </Typography>
                    )} */}
                  </Box>
                </DialogTitle>

                <Stepper
                  alternativeLabel
                  activeStep={activeStep}
                  connector={<ColorlibConnector />}
                  sx={{ py: 2 }}
                >
                  {steps.map((step, index) => (
                    <Step
                      key={step.label}
                      onClick={() => handleStepIconClick(index, formikProps)}
                      sx={{ cursor: "pointer" }}
                    >
                      <StepLabel StepIconComponent={ColorlibStepIcon}>
                        {step.label}
                      </StepLabel>
                    </Step>
                  ))}
                </Stepper>
              </Box>

              {/* Scrollable Content */}
              <DialogContent
                dividers
                ref={contentRef}
                sx={{
                  flexGrow: 1,
                  overflowY: "auto",
                  px: 3,
                  scrollbarWidth: "none", // Firefox
                  "&::-webkit-scrollbar": {
                    display: "none" // Chrome, Safari, Edge
                  }
                }}
              >
                {/* Your step content */}
                {activeStep === 0 && (
                  <BasicInformationForm formik={formikProps} />
                )}
                {activeStep === 1 && (
                  <EmploymentDetailsTab
                    formik={formikProps}
                    employeeId={employeeId}
                  />
                )}
                {activeStep === 2 && (
                  <SalaryInformationTab
                    formik={formikProps}
                    employeeId={employeeId}
                  />
                )}
                {activeStep === 3 && (
                  <LeaveInformationTab
                    formik={formikProps}
                    employeeId={employeeId}
                  />
                )}
                {activeStep === 4 && (
                  <ChallansTab
                    challans={challans}
                    selectedChallan={challan}
                    setSelectedChallan={setChallan}
                  />
                )}
                {activeStep === 5 && (
                  <PermissionsTab
                    formik={formikProps}
                    modulesData={permission_modules}
                    permissions={permissions}
                    setPermissions={setPermissions}
                  />
                )}
              </DialogContent>

              {/* Sticky Footer */}
              <DialogActions
                sx={{
                  position: "sticky",
                  bottom: 0,
                  backgroundColor: "background.paper",
                  px: 3,
                  py: 2,
                  borderTop: 1,
                  borderColor: "divider",
                  zIndex: 1000
                }}
              >
                <Button variant="outlined" onClick={handleClose}>
                  Cancel
                </Button>

                <Box sx={{ flexGrow: 1 }} />

                <Button
                  disabled={activeStep === 0}
                  onClick={() => setActiveStep((prev) => prev - 1)}
                >
                  Back
                </Button>
                {activeStep < steps.length - 1 ? (
                  <Button
                    type="button"
                    variant="contained"
                    disabled={isSubmitting}
                    onClick={() => handleNext(formikProps)}
                  >
                    Next
                  </Button>
                ) : (
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={isSubmitting}
                    onClick={() => handleFinalSubmit(values, setSubmitting)}
                  >
                    Submit
                  </Button>
                )}
              </DialogActions>

              {/* Loader */}
              {isLoding && activeStep === steps.length - 1 && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    height: "100vh",
                    width: "100vw",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: "rgba(255, 255, 255, 0.6)",
                    zIndex: 9999
                  }}
                >
                  <div
                    style={{
                      background:
                        "linear-gradient(45deg,rgb(65, 63, 63),rgb(238, 231, 238))",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent"
                    }}
                  >
                    <FadeLoader loading={true} size={150} />
                  </div>
                </div>
              )}
            </Form>
          );
        }}
      </Formik>
    </Dialog>
  );
};

export default AddEmployeeModal;

// const AddEmployeeModal = ({ open, handleClose, initialData = null }) => {
//   const [activeStep, setActiveStep] = useState(0);
//   const [permissions, setPermissions] = useState([]);
//   const [employeeId, setEmployeeId] = useState(null);
//   console.log(permissions);

//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const dispatch = useDispatch();
//   const isEdit = Boolean(initialData?.id);
//   const { getPermissionsModules } = MasterViewController();
//   const { addEmployee , updateEmployee,} = EmployeeProfileVeiwController();
//   const { permission_modules } = useSelector((state) => state.master);

//   useEffect(() => {
//     dispatch(getPermissionsModules());
//   }, [dispatch]);

//  const handleNext = (formikValues, setSubmitting) => {
//   setSubmitting(true);
//   try {
//     setActiveStep((prev) => prev + 1);
//   } catch (error) {
//     console.error("Error in handleNext:", error);
//   } finally {
//     setSubmitting(false);
//   }
// };

// const handleFinalSubmit = async (values, setSubmitting) => {
//   setSubmitting(true);

//   try {
//     const groupedPermissions = permissions.map((perm) => ({
//       module: perm.module,
//       moduleLabel: perm.moduleLabel,
//       approve: !!perm.approve,
//       archive: !!perm.archive,
//       assign: !!perm.assign,
//       create: !!perm.create,
//       delete: !!perm.delete,
//       edit: !!perm.edit,
//       enabled: !!perm.enabled,
//       export: !!perm.export,
//       generate_report: !!perm.generate_report,
//       import: !!perm.import,
//       reject: !!perm.reject,
//       restore: !!perm.restore,
//       unassign: !!perm.unassign,
//       view: !!perm.view,
//     }));

//     const combinedData = {
//       first_name: values.first_name,
//       last_name: values.last_name,
//       email: values.email,
//       mobile_number: values.mobile_number,
//       gender: values.gender,
//       nationality: values.nationality,
//       profile: {
//         joining_date: values.joining_date,
//         department: values.department,
//         designation: values.designation,
//         employment_type: values.employment_type,
//         work_location: values.work_location,
//         reporting_manager: values.reporting_manager,
//         employee_status: values.employee_status,
//         job_description: values.job_description,
//         shift_timing: values.shift_timing,
//         weekly_off: Array.isArray(values.weekly_off) ? values.weekly_off.join(", ") : values.weekly_off,
//         working_hours: values.working_hours,
//       },
//       employee_salary: {
//         basic_salary: values.basic_salary,
//         other_allowances: values.other_allowances,
//         deductions: values.deductions,
//         hra: values.hra,
//         bonus: values.bonus,
//       },
//       leave_balance: {
//         paid_leave_balance: values.paid_leave_balance,
//         unpaid_leave_balance: values.unpaid_leave_balance,
//         leave_approval_managers: values.leave_approval_managers,
//         leave_year: values.leave_year,
//         attendance_type: values.attendance_type,
//         overtime_eligible: values.overtime_eligible,
//         casualLeave: values.casualLeave,
//         sickLeave: values.sickLeave,
//         maternityLeave: values.maternityLeave,
//         marriageLeave: values.marriageLeave,
//         compensatoryOff: values.compensatoryOff,
//       },
//       permissions: {
//         permissions: groupedPermissions,
//       },
//     };

//     console.log("Final combined data to be sent:", combinedData);

//     const result = await dispatch(addEmployee(combinedData));

//     handleClose();
//   } catch (error) {
//     console.error("Failed to submit combined data:", error);
//   } finally {
//     setSubmitting(false);
//   }
// };

//   return (
//     <Dialog
//       open={open}
//       onClose={handleClose}
//       fullWidth={!isMobile}
//       maxWidth={isMobile ? false : "md"}
//       PaperProps={{
//         sx: {
//           height: "90vh",
//           display: "flex",
//           flexDirection: "column",
//           ...(isMobile && {
//             width: "95vw",
//             maxWidth: "95vw",
//             m: 1
//           })
//         }
//       }}
//     >
//       <Formik
//         initialValues={{
//           first_name: "",
//           last_name: "",
//           email: "",
//           mobile_number: "",
//           gender: "",
//           nationality: "",

//           department: "",
//           designation: "",
//           joining_date: "",
//           employment_type: "",
//           work_location: "",
//           reporting_manager: "",
//           employee_status: "",
//           job_description: "",
//           shift_timing: "",
//           weekly_off: "",
//           working_hours: "",

//           basic_salary: "",
//           other_allowances: "",
//           deductions: "",
//           bank_name: "",
//           account_number: "",
//           hra: "",
//           bonus: "",
//           ifsc_code: "",
//           pan_number: "",
//           pf_number: "",
//           esi_number: "",

//           paid_leave_balance: 0,
//           unpaid_leave_balance: 0,
//           leave_approval_managers: [],
//           attendance_type: "",
//           overtime_eligible: "",
//           casualLeave: 0,
//           sickLeave: 0,
//           maternityLeave: 0,
//           marriageLeave: 0,
//           compensatoryOff: 0
//         }}
//         validationSchema={validationSchema}
//         onSubmit={(values, { setSubmitting }) => {
//         setSubmitting(false);
//       }}

//       >
//         {(formikProps) => {
//           const { isSubmitting, values, setSubmitting } = formikProps;

//           return (
//             <Form
//               style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}
//             >
//               <Box
//                 sx={{
//                   position: "sticky",
//                   top: 0,
//                   zIndex: 1000,
//                   backgroundColor: "background.paper",
//                   px: 3,
//                   pt: 2
//                 }}
//               >
//                 <DialogTitle sx={{ borderBottom: 1, borderColor: "divider" }}>
//                   Add New Employee
//                   {employeeId && (
//                     <Typography variant="body2">
//                       Employee ID: {employeeId}
//                     </Typography>
//                   )}
//                 </DialogTitle>

//                 <Stepper
//                   alternativeLabel
//                   activeStep={activeStep}
//                   connector={<ColorlibConnector />}
//                   sx={{ py: 3 }}
//                 >
//                   {steps.map((step, index) => (
//                     <Step
//                       key={step.label}
//                       onClick={() => setActiveStep(index)}
//                       sx={{ cursor: "pointer" }}
//                     >
//                       <StepLabel StepIconComponent={ColorlibStepIcon}>
//                         {step.label}
//                       </StepLabel>
//                     </Step>
//                   ))}
//                 </Stepper>
//               </Box>

//               <DialogContent
//                 dividers
//                 sx={{
//                   flexGrow: 1,
//                   overflowY: "auto",
//                   px: 3
//                 }}
//               >
//                 {activeStep === 0 && (
//                   <BasicInformationForm formik={formikProps} />
//                 )}
//                 {activeStep === 1 && (
//                   <EmploymentDetailsTab formik={formikProps} employeeId={employeeId} />
//                 )}
//                 {activeStep === 2 && (
//                   <SalaryInformationTab formik={formikProps} employeeId={employeeId} />
//                 )}
//                 {activeStep === 3 && (
//                   <LeaveInformationTab formik={formikProps} employeeId={employeeId} />
//                 )}
//                 {activeStep === 4 && (
//                   <PermissionsTab
//                     formik={formikProps}
//                     modulesData={permission_modules}
//                     permissions={permissions}
//                     setPermissions={setPermissions}
//                   />
//                 )}
//               </DialogContent>

//               <DialogActions
//                 sx={{ px: 3, py: 2, borderTop: 1, borderColor: "divider" }}
//               >
//                 <Button onClick={handleClose} variant="outlined">
//                   Cancel
//                 </Button>

//                 <Box sx={{ flexGrow: 1 }} />

//                 <Button
//                   disabled={activeStep === 0}
//                   onClick={() => setActiveStep((prev) => prev - 1)}
//                 >
//                   Back
//                 </Button>

//                 {activeStep < steps.length - 1 ? (
//                   <Button
//                     type="button"
//                     variant="contained"
//                     disabled={isSubmitting}
//                     onClick={() => handleNext(values, setSubmitting)}
//                   >
//                     Next
//                   </Button>
//                 ) : (
//                   <Button
//                     type="submit"
//                     variant="contained"
//                     disabled={isSubmitting}
//                     onClick={() => handleFinalSubmit(values, setSubmitting)}
//                   >
//                     Submit
//                   </Button>
//                 )}
//               </DialogActions>
//             </Form>
//           );
//         }}
//       </Formik>
//     </Dialog>
//   );
// };
